import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import LocalizedField from './LocalizedField';
import SectionBlock from './SectionBlock';

export default function HostingDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  return (
    <Box>
      <SectionBlock title="Identity" />
      <LocalizedField
        label="Name"
        fieldKey="localizedName"
        data={data.localizedName}
        diffKeys={diffKeys}
        side={side}
      />
      <FieldRow
        label="Stream URL"
        value={data.streamUrl}
        isChanged={diffKeys.has('streamUrl')}
        side={side}
      />
      {/* Active field — hidden for now
      <FieldRow
        label="Active"
        value={data.isActive == null ? null : (data.isActive ? 'Yes' : 'No')}
        isChanged={diffKeys.has('isActive')}
        side={side}
      />
      */}
    </Box>
  );
}
